import request from '@/utils/request'

let PromotionApi = {

    /*获取推广人列表*/
    getProuserList(data, errorback) {
        return request._post('/shop/user.user_promotion/list', data, errorback);
    },
    // 添加推广人
    addProuserList(data, errorback) {
        return request._post('/shop/user.user_promotion/add', data, errorback);
    },
    // 编辑推广人
    editProuserList(data, errorback) {
        return request._post('/shop/user.user_promotion/edituser', data, errorback);
    },
    // 删除推广人
    delProuserList(data, errorback) {
        return request._post('/shop/user.user_promotion/delete', data, errorback);
    },
    delAllProuserList(data, errorback) {
        return request._post('/shop/user.user_promotion/deleteAll', data, errorback);
    },
    // 获取二维码
    getQrcodeUel(data, errorback) {
        return request._post('/shop/user.user_promotion/createQrcode', data, errorback);
    },
    // 获取推广列表
    getCountList(data, errorback) {
        return request._post('/shop/user.user_promotion/countList', data, errorback);
    },

    getTglogList: (data) => request._post('/shop/user.user_promotion/tglogindex', data, true),
    getTgOrderList: (data) => request._post('/shop/user.user_promotion/tgorder/', data, true),

}

export default PromotionApi;



// WEBPACK FOOTER //
// ./src/api/promotion.js